<template>
  <div>
    <h1>Hello, Vue!</h1>
    <p>This project is initialized using an Ansible playbook.</p>
  </div>
</template>
<script>
export default {
  name: "HelloWorld"
};
</script>
<style scoped>
h1 { color: green; }
</style>
